import * as telemetry from '@cian/telemetry/browser';

export function setupDependencies() {
  telemetry.setup();
}
